import React from 'react';
import { DropdownMenu } from "../DropdownMenu";
import { FullPageModalFooterCenter } from "../FullPageModal";
import { TextButton } from "../TextButton";
import { Typography } from "../Typography";
import styles from "./FullPageModalAdditionalActions.module.scss";
import { FullPageModalAdditionalActionsTestIds } from "./FullPageModalAdditionalActions.utils";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export function FullPageModalAdditionalActions(props) {
  const {
    inlineActions,
    dropdownActions
  } = props;
  const hasDropdownActions = dropdownActions.length > 0;
  return /*#__PURE__*/_jsx(FullPageModalFooterCenter, {
    children: /*#__PURE__*/_jsxs("div", {
      className: styles.root,
      "data-testid": props['data-testid'],
      children: [inlineActions.map((action, idx) => {
        const {
          text,
          testid,
          disabled,
          skin,
          intent,
          tooltipTitle,
          onClick
        } = action;
        const tooltip = tooltipTitle ? {
          title: tooltipTitle
        } : undefined;
        const isLast = idx === inlineActions.length - 1;
        return /*#__PURE__*/_jsxs(React.Fragment, {
          children: [/*#__PURE__*/_jsx(TextButton, {
            underline: "none",
            skin: skin || 'secondary',
            intent: intent,
            disabled: disabled,
            "data-testid": testid,
            tooltip: tooltip,
            onClick: onClick,
            children: text
          }), (!isLast || hasDropdownActions) && /*#__PURE__*/_jsx(Typography, {
            className: styles.sep,
            children: "|"
          })]
        }, text);
      }), hasDropdownActions && /*#__PURE__*/_jsx(DropdownMenu, {
        "data-testid": FullPageModalAdditionalActionsTestIds.DropdownMenu(),
        vAlign: "top",
        target: /*#__PURE__*/_jsx(TextButton, {
          skin: "secondary",
          underline: "none",
          "data-testid": FullPageModalAdditionalActionsTestIds.MoreButton(),
          children: "More"
        }),
        children: dropdownActions.map(action => {
          const {
            text,
            testid,
            disabled,
            skin,
            intent,
            iconStart,
            onClick,
            tooltipTitle
          } = action;
          const tooltip = tooltipTitle ? {
            title: /*#__PURE__*/_jsx("div", {
              "data-testid": testid && "".concat(testid, "-tooltip"),
              children: tooltipTitle
            })
          } : undefined;
          return /*#__PURE__*/_jsx(DropdownMenu.Item, {
            skin: skin,
            intent: intent,
            disabled: disabled,
            "data-testid": testid,
            iconStart: /*#__PURE__*/_jsx("div", {
              className: styles.actionIcon,
              children: iconStart
            }),
            onClick: onClick,
            tooltipProps: tooltip,
            children: text
          }, text);
        })
      })]
    })
  });
}